import _ from 'lodash';
import { fields } from './Fields';

const validate = values => {

    values = _.pickBy(values, _.identity);

    const msg_req = "Campo requerido";
    const errors = {};
    let constSubFieldsStep2  = [
        "Expansionar",
        "Extruir",
        "Comprimir",
        "Rotar",
        "Cerrar de espacios",
        "Dar torque",
        "Protuir",
        "Dar angulación TIP",
        "Retruir",
        "Mesializar",
        "Intruir",
        "Distalar"
    ]
    const filedsASup = constSubFieldsStep2.map((item) => {
        return _.snakeCase(item+" Arcada superior")
    })
    const filedsAInf = constSubFieldsStep2.map((item) => {
        return _.snakeCase(item+" Arcada inferior")
    })
    function textChecker(fieldsArray) {
        if(_.some(fieldsArray, function(o){ return _.has(values, o) })){
            fieldsArray.forEach(item => {
                if(values[item] && !values[item + "_text"]){
                    console.log(item)
                    errors[item + "_text"] = "Debe introducir alguna descripción"
                }
            })
        }

    }
    let fieldsStep3 = _.cloneDeep(fields.stepThree.fields);
    fieldsStep3 = _.keyBy(fieldsStep3.map((item)=>{
        item.name = _.snakeCase(item.name)
        return item
    }), "name");
    let auxStep3 = _.cloneDeep(fields.stepThree.aux.items);
    auxStep3 = _.keyBy(auxStep3.map((item)=>{
        item.name = _.snakeCase(item.name)
        return item
    }), "name");

    if (!values.nombre) {
        errors.nombre = msg_req;
    }
    if (!values.apellidos) {
        errors.apellidos = msg_req;
    }
    if (values.phone && !/^(([\+]?[ 0-9]{1,6}([ \.\-])?)?([\(]{1}[ +0-9]{2,6}[\)])?([ 0-9A-Z\.\-]{1,32})([0-9]+))|((e|x|ex|ext|extension)(\.|\:)?([ ]{1})?[0-9]+)$/i.test(values.phone)) {
        errors.phone = 'Número de teléfono invalido';
    }
    if (!values.envio) {
        errors.envio = msg_req;
    }
    if (!values.entrega) {
        errors.entrega = msg_req;
    }
    if (!values.piezas_protesicas) {
        errors.piezas_protesicas = msg_req;
    }
    if (!values.aux) {
        errors.aux = msg_req;
    }
    if(values.aux == "si" && !_.some(auxStep3, { 'active': true })){
        errors.aux = msg_req;
    }
    if (!values.address || values.address === "_0" || values.address === "_1") {
        errors.address = msg_req;
    }
    if ((!values.billing_address_checker && !values.billing_address) || values.billing_address === "_1" || values.billing_address === "_0") {
        errors.billing_address = msg_req;
    }
    if (!values.arcada_superior && !values.arcada_inferior) {
        errors.arcada_superior = "Elija al menos una arcada"
        errors.arcada_inferior = "Elija al menos una arcada"
    }
    if(!_.some(filedsASup, function(o){ return _.has(values, o) }) && values.arcada_superior){
        errors.arcada_superior = "Debe elegir al menos una opción"
    }
    textChecker(filedsASup)
    if(!_.some(filedsAInf, function(o){ return _.has(values, o) }) && values.arcada_inferior){
        errors.arcada_inferior = "Debe elegir al menos una opción"
    }
    textChecker(filedsAInf)


    _.forOwn(values, function(value, key) {
        let childFields;
        if(fieldsStep3[key] && fieldsStep3[key].items.length > 0 && fieldsStep3[key].active && value !== "no" && fieldsStep3[key].hasOwnProperty("type") && fieldsStep3[key].type !== "group"){
            let itemKeys = _.keyBy(fieldsStep3[key].items.map((item)=>{
                item.name = _.snakeCase(item.name+" "+key)
                return item
            }), "name");
            childFields = _.map(itemKeys, function(o){ return o.name });

            let valuesArray = _.keys(values);
            if(_.difference(childFields, valuesArray).length === childFields.length){
                errors[key] = `Debe elegir al menos una de las ${childFields.length} opciones`
            }
            textChecker(childFields)
        } else if(fieldsStep3[key] && fieldsStep3[key].hasOwnProperty("type") && fieldsStep3[key].type === "group"){
            let allGroupFields = []

            if(fieldsStep3[key].name === "centrar_linea_media"){
                allGroupFields = [
                    "centrar_linea_media_desviacion_superior",
                    "centrar_linea_media_desviacion_inferior"
                ]
            }
            allGroupFields = _.flattenDeep(allGroupFields)
            if(!_.some(allGroupFields, function(o){ return _.has(values, o) })){
                errors[key] = `Debe seleccionar al menos una de las ${allGroupFields.length} opciones`
            }
        }
        if(fieldsStep3[key] && fieldsStep3[key].items.length === 0 && fieldsStep3[key].desc){
            if (!values[key + "_text"]) {
                errors[key] = `Debe rellenar el campo de texto con inciaciones`
            }
        }

    });

    _.forOwn(values, function(value, key) {
        let childFields;

        if(auxStep3[key] && auxStep3[key].items.length > 0 && auxStep3[key].active && auxStep3[key].type !== "group"){
            let itemKeys = _.keyBy(auxStep3[key].items.map((item)=>{
                item.name = _.snakeCase(item.name+" "+key)
                return item
            }), "name");
            childFields = _.map(itemKeys, function(o){ return o.name });

            let valuesArray = _.keys(values);
            if(_.difference(childFields, valuesArray).length === childFields.length){
                errors[key] = `Debe elegir al menos una de las ${childFields.length} opciones`
            }
            textChecker(childFields)
        } else if(auxStep3[key] && auxStep3[key].hasOwnProperty("type") && auxStep3[key].type === "group"){
            console.log(auxStep3[key])
            let allGroupFields = []

            auxStep3[key].items.forEach(item => {
                item.items.forEach(subitem => {
                    let itemKeys = _.keyBy(subitem.items.map((option)=>{
                        option.name = _.snakeCase(key + " " + subitem.name + " " + option.name)
                        return option
                    }), "name");
                    allGroupFields.push(_.map(itemKeys, function(o){ return o.name }));
                })
            })
            allGroupFields = _.flattenDeep(allGroupFields)
            if(!_.some(allGroupFields, function(o){ return _.has(values, o) })){
                errors[key] = `Debe seleccionar al menos una de las ${allGroupFields.length} opciones`
            }



        }
        if(auxStep3[key] && auxStep3[key].items.length === 0 && auxStep3[key].desc) {
            if (!values[key + "_text"]) {
                errors[key] = `Debe rellenar el campo de texto con inciaciones`
            }
        }

        if(!values.fotos || values.nofotos){
            errors.fotos = "Añada archivos o indique expresamente que el estudio se realizará sin estos archivos"
        }
        if(!values.radios || values.noradios){
            errors.radios = "Añada archivos o indique expresamente que el estudio se realizará sin estos archivos"
        }
        if(!values.dicoms || values.nodicoms){
            errors.dicoms = "Añada archivos o indique expresamente que el estudio se realizará sin estos archivos"
        }
    });

    return errors;
};

export default validate;


// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/newcaso/validation.js